const getNodeWidth = (node) => {
  if (node.measured?.width) {
    return node.measured.width
  }

  const size = node.data?.nodeProps?.size
  const padding = 20
  const border = 4

  const minWidth = size === 'lg' ? 200 : size === 'sm' ? 120 : 160

  return minWidth + padding + border
}

export function layoutFamilyTree ({ nodes, edges, centerId, config }) {
  const familyTreeConfig = config?.familyTree || config || {}
  const verticalSpacing = familyTreeConfig?.verticalSpacing ?? 200
  const horizontalGap = familyTreeConfig?.horizontalGap ?? 90

  if (nodes.length === 0) {
    return { nodes: [], edges: [] }
  }

  const nodesByDepth = {}
  nodes.forEach(node => {
    const depth = node.data.entityProps?.familyTreeDepth ?? 0
    if (!nodesByDepth[depth]) {
      nodesByDepth[depth] = []
    }
    nodesByDepth[depth].push(node)
  })

  const depths = Object.keys(nodesByDepth).map(Number).sort((a, b) => a - b)

  depths.forEach(depth => {
    const nodesAtDepth = nodesByDepth[depth]

    const totalWidth = nodesAtDepth.reduce((sum, node, index) => {
      const nodeWidth = getNodeWidth(node)
      return sum + nodeWidth + (index < nodesAtDepth.length - 1 ? horizontalGap : 0)
    }, 0)

    let currentX = -totalWidth / 2

    nodesAtDepth.forEach((node) => {
      const nodeWidth = getNodeWidth(node)

      node.position = {
        x: currentX,
        y: depth * verticalSpacing
      }

      currentX += nodeWidth + horizontalGap
    })
  })

  return { nodes, edges }
}
